import type { MessageLogRecord } from "../types";
import { formatDateTime } from "../utils/format";

function DeliveryBadge({ log }: { log: MessageLogRecord }) {
  if (log.direction !== "outbound") return <span className="faint">—</span>;
  if (log.delivered_at) {
    return (
      <span className="badge badge-normal">
        <span className="badge-dot" />
        Delivered
      </span>
    );
  }
  const isExpired = log.expires_at !== null && new Date(log.expires_at).getTime() <= Date.now();
  if (isExpired) {
    return (
      <span className="badge badge-offline">
        <span className="badge-dot" />
        Expired
      </span>
    );
  }
  return (
    <span className="badge badge-degraded">
      <span className="badge-dot" />
      Pending
    </span>
  );
}

export function MessageLogsList({ logs }: { logs: MessageLogRecord[] }) {
  if (logs.length === 0) {
    return (
      <div className="empty-state">
        <p>No messages recorded yet. Send one from the Command Bar on a server's Status tab.</p>
      </div>
    );
  }

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Timestamp</th>
          <th>Direction</th>
          <th>Type</th>
          <th>Message</th>
          <th>Delivery</th>
        </tr>
      </thead>
      <tbody>
        {logs.map((log) => (
          <tr key={log.id}>
            <td className="mono">{formatDateTime(log.timestamp)}</td>
            <td>{log.direction}</td>
            <td className="mono">{log.message_type}</td>
            <td className="mono" style={{ maxWidth: "360px", wordBreak: "break-word" }}>
              {log.metadata ?? "—"}
            </td>
            <td>
              <DeliveryBadge log={log} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
